(function($) {
	$(function() {
		if ($('.ajax-target').length !== 1) {
			return;
		}

		let last_filter_count = $('.ajax-target').data('filter-count');
		let featured_section = $('.content--featured');

		let accordion_button = $('#js-filter-button');
		let accordion_form = $('#js-filter-wrapper');

		// Animates closing the news filters with appropriate class manipulation
		function closeFilter() {
			accordion_form.removeClass('open');
			accordion_form.addClass('closed');
			accordion_button.removeClass('menu-toggle--open');
			accordion_button.addClass('menu-toggle--closed');
			accordion_form.stop(true, false).slideUp('slow');
		}

		// Animates opening the news filters with appropriate class manipulation
		function openFilter() {
			accordion_form.removeClass('closed');
			accordion_form.addClass('open');
			accordion_button.removeClass('menu-toggle--closed');
			accordion_button.addClass('menu-toggle--open');
			accordion_form.stop(true, false).slideDown('slow');
		}

		if (accordion_form.length && accordion_button.length) {
			if (
				$(window).width() < wp_data.breakpoints.medium &&
				accordion_button.hasClass('menu-toggle--closed')
			) {
				closeFilter();
			}
		}

		// helper function for finding out the needed height of the Featured section when open
		function get_featured_height() {
			if (featured_section.length) {
				return (
					$(
						'.content--featured .section--featured-posts'
					).outerHeight() +
					$(
						'.content--featured .featured-posts__heading'
					).outerHeight()
				);
			}
			return '0px';
		}

		// Due to some other JS in the site, which checks to see if an object is on screen and hides it if its not
		// This function when called will make sure that this components DOM hasn't been hidden by someone else.

		function enforce_featured_section_visible() {
			$('.content--featured section .contained').addClass('is-visible');
		}

		// helper function for setting the height of the Featured Posts section
		// (so we can check for element existence in one place).
		function set_featured_height(height_in_px) {
			if (featured_section.length) {
				featured_section.css('max-height', height_in_px);
			}
		}

		// Animate closing the featured section
		function hide_featured() {
			set_featured_height(get_featured_height());

			setTimeout(function() {
				set_featured_height('0px');
			}, 100);
		}

		// Animate opening the featured section
		function show_featured() {
			set_featured_height('0px');
			enforce_featured_section_visible();

			setTimeout(function() {
				set_featured_height(get_featured_height());
			}, 100);
		}

		// This function should be called whenever the filter count may have changed
		// It will set the featured hight correctly, and animate a change if needed
		function apply_featured_height(this_filter_count) {
			// potentially confusing logic here, if filter count is 0, we want to SHOW featured
			// if filter count is > 0, we want to HIDE featured

			if (last_filter_count === 0) {
				// we WERE showing the featured

				if (this_filter_count > 0) {
					// Featured should be closing, animate it
					hide_featured();
				} else {
					// Featured should stay open, no animation
					set_featured_height(get_featured_height());
					enforce_featured_section_visible();
				}
			} else if (last_filter_count > 0) {
				// we WERE hiding the featured
				if (this_filter_count === 0) {
					// Featured should be opening, animate it
					show_featured();
				} else {
					// Featured should stay closed, no animation
					set_featured_height('0px');
				}
			}
		}

		// This function blurs the news archive while the AJAX results are
		// being loaded
		function news_archive_goto_loading_state() {
			$('.ajax-target').addClass('loading');
		}

		// This function AJAX loads the news archive for a given request
		function do_news_archive_ajax_load(request) {
			request = request + '&post=' + $('.ajax-target').data('ajax-page');

			news_archive_goto_loading_state();

			$.ajax({
				url: request,
				success: function(data) {
					$('.ajax-target').replaceWith(data);
					bind_all_news_archive_functions();
					openFilter();
					setTimeout(function() {
						$('.ajax-target.loading').removeClass('loading');
					}, 100);
				},
			});
		}

		// This function creates an AJAX request, handles the featured posts,
		// pushes to browser history, and then AJAX loads the news archive
		function do_ajax_load_with_target(target) {
			let request = wp_data.ajax_url + '?action=bru_news_archive_filter';

			let query = target.split('?');
			if (query.length === 2) {
				request = request + '&' + query[1];

				// Speculatively open / close featured
				apply_featured_height(1);
				last_filter_count = 1;
			} else {
				// Speculatively open / close featured
				apply_featured_height(0);
				last_filter_count = 0;
			}

			window.history.pushState(null, null, target);

			do_news_archive_ajax_load(request);
		}

		// This function runs the AJAX load function: triggered by a select box
		function do_ajax_load_for_select(e) {
			do_ajax_load_with_target(
				$(this)
					.children('option:selected')
					.data('href')
			);
			e.preventDefault();
			return false;
		}

		// This function runs the AJAX load function: triggered by a link click
		function do_ajax_load_for_link(e) {
			do_ajax_load_with_target($(this).attr('href'));
			e.preventDefault();
			return false;
		}

		// This function sets up all the JS hooks on the page both for main
		// render and any ajax render
		function bind_all_news_archive_functions() {
			let this_filter_count = $('.ajax-target').data('filter-count');
			let news_archive_filters = $(
				'.news-archive-content .js-filter-select'
			);
			let filter_buttons = $('.js-filter-button');

			// this variable need to be rebound, since the DOM has changed.
			featured_section = $('.content--featured');

			accordion_button = $('#js-filter-button');
			accordion_form = $('#js-filter-wrapper');

			apply_featured_height(this_filter_count);
			last_filter_count = this_filter_count;

			news_archive_filters.change(do_ajax_load_for_select);

			filter_buttons.click(do_ajax_load_for_link);

			if (accordion_button.length && accordion_form.length) {
				accordion_button.on('click', function() {
					if (accordion_form.hasClass('open')) {
						closeFilter();
					} else {
						openFilter();
					}
				});
			}
		}

		// Call function to setup page on page load
		bind_all_news_archive_functions();

		// Remove loading class as page is now loaded
		$('.ajax-target.loading').removeClass('loading');
	});
})(jQuery);
